import $ from 'jquery'
import random from 'toxilibs/random.js'

function QuestionGeneratorHelper () {
    this.container = $('<div class="challenge_question">')
    this.todoOnDisplay = []
}


function answerPlaceholderFilter (string) {
    return string.replace('ANSWER_HERE', '<span class="answer_placeholder">?</span>')
}


QuestionGeneratorHelper.textFilters = [answerPlaceholderFilter]




QuestionGeneratorHelper.prototype.smartChoose = function (rounds, callback) {
    const choices = selectRoundChoices(this, rounds)

    if (Array.isArray(choices)) {
        callback(random.fairChoice(choices))
        return
    }

    const values = {}
    for (let key in choices) {
        let keyChoices = choices[key]
        if (!Array.isArray(keyChoices)) {
            keyChoices = [keyChoices]
        }
        values[key] = random.fairChoice(keyChoices, {name: key})
    }
    callback(values)
}


QuestionGeneratorHelper.prototype.intBetween = function (min, max) {
    const choices = []
    for (let i = min; i <= max; i++) {
        choices.push(i)
    }
    return choices
}



function selectRoundChoices (questionGeneratorHelper, rounds) {
    let availableUntil = 0
    let round

    for (let i = 0; i < rounds.length; i++) {
        round = rounds[i]

        const times = getOnlyKey(round)

        if (times === 'all') {
            return getChoicesFromRound(round)
        }

        availableUntil += parseInt(times, 10)
        if (questionGeneratorHelper.currentTry <= availableUntil) {
            return getChoicesFromRound(round)
        }
    }
    return getChoicesFromRound(round)
}


function getChoicesFromRound (round) {
    let choices = getOnlyValue(round)

    if (Array.isArray(choices) && typeof choices[0] === 'object') {
        choices = random.pick(choices)
    }

    if (typeof choices === 'object') {
        return choices
    } else {
        return [choices]
    }
}


function getOnlyKey (object) {
    //FIXME use Object.keys()[0]
    let i = 0
    let key
    for (key in object) {
        i++
    }
    if (i !== 1) {
        throw new Error('object should have only one key')
    }
    return key
}


function getOnlyValue (object) {
    let i = 0
    let key
    for (key in object) {
        i++
    }
    if (i !== 1) {
        throw new Error('object should have only one key')
    }
    return object[key]
}


QuestionGeneratorHelper.prototype.addClass = function (string) {
    this.container.addClass(string)
}


QuestionGeneratorHelper.prototype.addText = function (string) {
    this.container.append('<pre class="text">' + applyTextFilters(string) + '</pre>')
}


QuestionGeneratorHelper.prototype.approximation = function (value, delta) {
    return function (userAnswer) {
        const number = parseFloat(userAnswer.replace(',', '.')) // the decimal comma, in french
        return number <= value + delta && number >= value - delta
    }
}


QuestionGeneratorHelper.prototype.evalAnswer = function (numericAnswer) {
    return function (userAnswer) {
        try {
            const isCorrect = eval(userAnswer) === numericAnswer //eslint-disable-line no-eval
            return isCorrect
        } catch (e) {
            return false
        }
    }
}


QuestionGeneratorHelper.prototype.display = function (done) {
    processToDo(this.todoOnDisplay, 0, done)
}



function processToDo (toDos, index, done) {
    const toDo = toDos[index]

    if (!toDo) {
        done()
        return
    }

    toDo(function () {
        processToDo(toDos, index + 1, done)
    })
}



function applyTextFilters (string) {
    for (let i = 0; i < QuestionGeneratorHelper.textFilters.length; i++) {
        string = QuestionGeneratorHelper.textFilters[i](string)
    }
    return string
}


export default QuestionGeneratorHelper

